<template>
  <div>
    <slot></slot>
    <v-dialog v-model="showErrorBar" persistent scrollable max-width="700px">
      <v-card>
        <v-card-text class="pt-5">
          <v-alert dense outlined type="error">
            Ett fel har inträffat, kopiera felkoden och kontakta support så underlättar det felsökningen.
          </v-alert>
          {{ currentErrors }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="onCopyToClipboard"> {{errorsCopied ? 'Kopierat!' : 'Kopiera felet'}} </v-btn>
          <v-btn color="green darken-1" text @click="onClose"> Stäng </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ErrorHandler',
  data() {
    return {
      showErrorBar: false,
      currentErrors: [],
      errorsCopied: false,
    }
  },
  mounted() {
    window.onerror = this.logError
    window.addEventListener('unhandledrejection', this.onUnhandledRejection)
  },
  errorCaptured(err, vm, info) {
    this.logError(err.message, err.stack)
    return false
  },
  beforeDestroy() {
    window.removeEventListener('unhandledrejection', this.onUnhandledRejection)
    window.onerror = null
  },
  methods: {
    logError(...args) {
      const errors = args.map((arg, i) => ({ [i]: arg }))
      this.currentErrors.push(errors)
      this.showErrorBar = true
    },
    onClose() {
      this.showErrorBar = false
      this.currentErrors = []
    },

    async onCopyToClipboard() {
       await navigator.clipboard.writeText(JSON.stringify(this.currentErrors));
       this.errorsCopied = true;
       this.currentErrors = []
    },
    onUnhandledRejection({ promise, reason }) {
      this.logError(promise, reason)
    },
  },
}
</script>

<style lang="less" scoped>
.errors {
  max-width: 100%;
  max-height: 100%;
  color: #000;
  opacity: 0.85;
  overflow-y: auto;
  overflow-y: hidden;

  pre {
    word-break: break-all;
    overflow-y: auto;
    overflow-y: hidden;
  }
}
</style>
